import React from 'react'

export default ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-full bg-white border border-gray-200 rounded-lg p-3 hover:border-primary-500 hover:shadow-md transition-all duration-200 text-center group"
  >
    <svg
      className="w-5 h-5 text-gray-400 group-hover:text-primary-600 mx-auto mb-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
    <span className="text-gray-900 font-medium text-sm">Others</span>
  </button>
)
